import script from "./WebDemo.vue?vue&type=script&setup=true&lang=js"
export * from "./WebDemo.vue?vue&type=script&setup=true&lang=js"

import "./WebDemo.vue?vue&type=style&index=0&id=57667fac&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57667fac"]])

export default __exports__